import React from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import { DashboardBlackIcon, DashboardWhiteIcon, LogoutBlackIcon, PlansBlackIcon, PlansWhiteIcon, SettingsBlackIcon, SettingsWhiteIcon, StoreBlack2Icon, StoreBlackIcon, StoreWhite2Icon, StoreWhiteIcon, SubscriptionBlackIcon, SubscriptionWhiteIcon, UserReportBlackIcon, UserReportWhiteIcon, UsersGroupBlackIcon, UsersGroupWhiteIcon } from "../../assets/icons";

const SuperAdminSettingsNavbar: React.FC = () => {

    const { logout } = useAuth();

    return (
        <section className="navbar">
            <div className="w-layout-blockcontainer container navbar-container w-container">
                <div className="navbar-wrapper">
                    <div className="navbar-header-div">
                        <div className="navbar-header-local-name">Super Admin Settings</div>
                        {/* <div className="navbar-header-info">Admin Panel</div> */}
                    </div>
                    <div className="navbar-list">

                        <NavLink to="/sa-settings/dashboard" style={{ textDecoration: "none" }} className={({ isActive }) => isActive ? "navbar-entity navbar-entity-selected" : "navbar-entity"}>
                            {({ isActive }) => (
                                <>
                                    <div className="navbar-entity-photo-div">
                                        <img loading="lazy" src={isActive ? DashboardWhiteIcon : DashboardBlackIcon} alt="" className="navbar-entity-photo" />
                                    </div>
                                    <div className="navbar-entity-name">Dashboard</div>
                                </>
                            )}
                        </NavLink>

                        <NavLink to="/sa-settings/locals" style={{ textDecoration: "none" }} className={({ isActive }) => isActive ? "navbar-entity navbar-entity-selected" : "navbar-entity"}>
                            {({ isActive }) => (
                                <>
                                    <div className="navbar-entity-photo-div">
                                        <img loading="lazy" src={isActive ? StoreWhite2Icon : StoreBlack2Icon} alt="" className="navbar-entity-photo" />
                                    </div>
                                    <div className="navbar-entity-name">Locals</div>
                                </>
                            )}
                        </NavLink>

                        <NavLink to="/sa-settings/owners" style={{ textDecoration: "none" }} className={({ isActive }) => isActive ? "navbar-entity navbar-entity-selected" : "navbar-entity"}>
                            {({ isActive }) => (
                                <>
                                    <div className="navbar-entity-photo-div">
                                        <img loading="lazy" src={isActive ? UsersGroupWhiteIcon : UsersGroupBlackIcon} alt="" className="navbar-entity-photo" />
                                    </div>
                                    <div className="navbar-entity-name">Owners</div>
                                </>
                            )}
                        </NavLink>

                        <NavLink to="/sa-settings/subscription" style={{ textDecoration: "none" }} className={({ isActive }) => isActive ? "navbar-entity navbar-entity-selected" : "navbar-entity"}>
                            {({ isActive }) => (
                                <>
                                    <div className="navbar-entity-photo-div">
                                        <img loading="lazy" src={isActive ? SubscriptionWhiteIcon : SubscriptionBlackIcon} alt="" className="navbar-entity-photo" />
                                    </div>
                                    <div className="navbar-entity-name">Subscrption</div>
                                </>
                            )}
                        </NavLink>

                        <NavLink to="/sa-settings/plans" style={{ textDecoration: "none" }} className={({ isActive }) => isActive ? "navbar-entity navbar-entity-selected" : "navbar-entity"}>
                            {({ isActive }) => (
                                <>
                                    <div className="navbar-entity-photo-div">
                                        <img loading="lazy" src={isActive ? PlansWhiteIcon : PlansBlackIcon} alt="" className="navbar-entity-photo" />
                                    </div>
                                    <div className="navbar-entity-name">Plans</div>
                                </>
                            )}
                        </NavLink>

                        <NavLink to="/sa-settings/users" style={{ textDecoration: "none" }} className={({ isActive }) => isActive ? "navbar-entity navbar-entity-selected" : "navbar-entity"}>
                            {({ isActive }) => (
                                <>
                                    <div className="navbar-entity-photo-div">
                                        <img loading="lazy" src={isActive ? UsersGroupWhiteIcon : UsersGroupBlackIcon} alt="" className="navbar-entity-photo" />
                                    </div>
                                    <div className="navbar-entity-name">Users</div>
                                </>
                            )}
                        </NavLink>

                        <NavLink to="/sa-settings/user-reports" style={{ textDecoration: "none" }} className={({ isActive }) => isActive ? "navbar-entity navbar-entity-selected" : "navbar-entity"}>
                            {({ isActive }) => (
                                <>
                                    <div className="navbar-entity-photo-div">
                                        <img loading="lazy" src={isActive ? UserReportWhiteIcon : UserReportBlackIcon} alt="" className="navbar-entity-photo" />
                                    </div>
                                    <div className="navbar-entity-name">Users Reports</div>
                                </>
                            )}
                        </NavLink>

                        <NavLink to="/sa-settings/settings" style={{ textDecoration: "none" }} className={({ isActive }) => isActive ? "navbar-entity navbar-entity-selected" : "navbar-entity"}>
                            {({ isActive }) => (
                                <>
                                    <div className="navbar-entity-photo-div">
                                        <img loading="lazy" src={isActive ? SettingsWhiteIcon : SettingsBlackIcon} alt="" className="navbar-entity-photo" />
                                    </div>
                                    <div className="navbar-entity-name">Settings</div>
                                </>
                            )}
                        </NavLink>

                        <NavLink to="/sa-settings/cities" style={{ textDecoration: "none" }} className={({ isActive }) => isActive ? "navbar-entity navbar-entity-selected" : "navbar-entity"}>
                            {({ isActive }) => (
                                <>
                                    <div className="navbar-entity-photo-div">
                                        <img loading="lazy" src={isActive ? SettingsWhiteIcon : SettingsBlackIcon} alt="" className="navbar-entity-photo" />
                                    </div>
                                    <div className="navbar-entity-name">Cities</div>
                                </>
                            )}
                        </NavLink>

                        <NavLink to="/sa-settings/location-areas" style={{ textDecoration: "none" }} className={({ isActive }) => isActive ? "navbar-entity navbar-entity-selected" : "navbar-entity"}>
                            {({ isActive }) => (
                                <>
                                    <div className="navbar-entity-photo-div">
                                        <img loading="lazy" src={isActive ? SettingsWhiteIcon : SettingsBlackIcon} alt="" className="navbar-entity-photo" />
                                    </div>
                                    <div className="navbar-entity-name">Location Areas</div>
                                </>
                            )}
                        </NavLink>

                        <NavLink to="/sa-settings/tags" style={{ textDecoration: "none" }} className={({ isActive }) => isActive ? "navbar-entity navbar-entity-selected" : "navbar-entity"}>
                            {({ isActive }) => (
                                <>
                                    <div className="navbar-entity-photo-div">
                                        <img loading="lazy" src={isActive ? SettingsWhiteIcon : SettingsBlackIcon} alt="" className="navbar-entity-photo" />
                                    </div>
                                    <div className="navbar-entity-name">Tags</div>
                                </>
                            )}
                        </NavLink>

                    </div>
                    <div className="navbar-footer-div">
                        <div style={{ textDecoration: "none" }} className="navbar-footer-entity-div log-out" onClick={() => logout()}>
                            <img loading="lazy" src={LogoutBlackIcon} alt="" className="navbar-entity-photo" />
                            <div className="text-block-22">Odjavi se</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SuperAdminSettingsNavbar;